import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/slices/auth.slice";

import EditProfile from "../forms/EditProfile";
import ProfileBanner from "./ProfileBanner";
import { serverUrl } from "../../nestserver";
import SocialButton from "../widgets/SocialButton";

function MainProfile() {
  const user = useSelector(selectUser);

  return (
    <ProfileBanner
      userId={user?._id}
      roleData={user?.teacher}
      patchUrl={serverUrl + "/teachers/" + user?.teacher?._id}
      EditFormComponent={EditProfile}
      extraContent={
        <div className="flex items-center space-x-4">
          {user?.teacher?.social_links?.map((item, index) => (
            <SocialButton key={index} data={item} />
          ))}
        </div>
      }
    />
  );
}

export default MainProfile;
